export default {
  'aiAgentTeam.title': 'Gestionar Equipos de Agentes IA',
};
